import LegalLayout from "@/components/LegalLayout";

export default function Widerruf() {
  return (
    <LegalLayout title="Widerrufsbelehrung">
      <h2>Widerrufsrecht für Verbraucher</h2>
      <p>
        Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken
        abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen
        beruflichen Tätigkeit zugerechnet werden können.
      </p>

      <h2>Widerrufsbelehrung</h2>

      <h3>Widerrufsrecht</h3>
      <p>
        Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag
        zu widerrufen.
      </p>
      <p>
        Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
      </p>
      <p>
        Um Ihr Widerrufsrecht auszuüben, müssen Sie uns
      </p>
      <p>
        <strong>AutoGlas Erol GmbH</strong><br />
        Frankenthalerstr. 98<br />
        67059 Ludwigshafen<br />
        Deutschland<br />
        Tel.: 0621 527429<br />
        E-Mail: info@billigautoglas.de
      </p>
      <p>
        mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief,
        Telefax oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen,
        informieren. Sie können dafür das untenstehende Muster-Widerrufsformular
        verwenden, das jedoch nicht vorgeschrieben ist.
      </p>
      <p>
        Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die
        Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
      </p>

      <h3>Folgen des Widerrufs</h3>
      <p>
        Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von
        Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der
        zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der
        Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt
        haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag
        zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei
        uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel,
        das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit
        Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen
        wegen dieser Rückzahlung Entgelte berechnet.
      </p>
      <p>
        Haben Sie verlangt, dass die Dienstleistungen während der Widerrufsfrist beginnen
        sollen, so haben Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil der
        bis zu dem Zeitpunkt, zu dem Sie uns von der Ausübung des Widerrufsrechts
        hinsichtlich dieses Vertrags unterrichten, bereits erbrachten Dienstleistungen im
        Vergleich zum Gesamtumfang der im Vertrag vorgesehenen Dienstleistungen
        entspricht.
      </p>

      <h2>Vorzeitiges Erlöschen des Widerrufsrechts</h2>
      <p>
        Das Widerrufsrecht erlischt bei einem Vertrag zur Erbringung von Dienstleistungen
        auch dann, wenn wir die Dienstleistung vollständig erbracht haben und mit der
        Ausführung der Dienstleistung erst begonnen haben, nachdem Sie dazu Ihre
        ausdrückliche Zustimmung gegeben haben und gleichzeitig Ihre Kenntnis davon
        bestätigt haben, dass Sie Ihr Widerrufsrecht bei vollständiger Vertragserfüllung
        durch uns verlieren.
      </p>
      <p>
        <strong>Hinweis für Eil-Termine (Glasreparatur innerhalb von 24 Stunden):</strong>{" "}
        Wenn Sie ausdrücklich verlangen, dass wir die Reparatur- bzw. Montageleistung
        bereits vor Ablauf der 14-tägigen Widerrufsfrist beginnen oder vollständig
        ausführen, bestätigen Sie damit Ihre Kenntnis darüber, dass Sie Ihr Widerrufsrecht
        bei vollständiger Vertragserfüllung verlieren bzw. bei Teilausführung anteilig
        Wertersatz schulden.
      </p>

      <h2>Muster-Widerrufsformular</h2>
      <p>
        (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular
        aus und senden Sie es zurück.)
      </p>

      <div className="not-prose rounded-xl border border-slate-200 bg-slate-50 p-5 text-sm leading-relaxed text-slate-800 space-y-2 my-4">
        <p>
          <strong>An</strong><br />
          AutoGlas Erol GmbH<br />
          Frankenthalerstr. 98<br />
          67059 Ludwigshafen<br />
          Deutschland<br />
          E-Mail: info@billigautoglas.de
        </p>
        <p>
          Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag
          über die Erbringung der folgenden Dienstleistung (*) / den Kauf der folgenden
          Waren (*):
        </p>
        <p>____________________________________________</p>
        <p>Bestellt am (*) / erhalten am (*): __________________</p>
        <p>Name des/der Verbraucher(s): __________________</p>
        <p>Anschrift des/der Verbraucher(s): __________________</p>
        <p>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier): __________________</p>
        <p>Datum: __________________</p>
        <p className="text-xs text-slate-500">(*) Unzutreffendes streichen.</p>
      </div>

      <p className="text-xs text-slate-500 mt-6">
        Quelle: Amtliches Muster gemäß Anlage 1 und Anlage 2 zu Artikel 246a § 1 Absatz 2
        Satz 1 Nummer 1 und § 2 Absatz 2 Nummer 2 EGBGB.
      </p>
    </LegalLayout>
  );
}
